import logo from './logo.svg';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import GalleryPage from './pages/GalleryPage';
import Activity from './pages/Activity';
import Camp from './pages/Camp';
import Team from './pages/Team';
import Developer from './pages/Developer';
import CampDetail from './pages/CampDetail';
import { Routes,Route } from 'react-router-dom';

import './App.css';
import Detail from './pages/Detail';

function App() {
  return (
    <>
    {/* <div>hi</div> */}
     <div  style={{ backgroundImage: "urlhttps://static.vecteezy.com/system/resources/previews/000/533/663/original/colorful-hands-prints-background-vector.jpg)",backgroundSize:'cover' }}>
      <div className="">
        <Navbar/>
      </div>
      <div className="mt-3">.</div>
      <div className="mt-5">
        <Routes>
        <Route exact path ="/" element={<Home/>}/>
        <Route exact path ="/activity" element={<Activity/>}/>
        <Route exact path ="/activity/:id" element={<Detail/>}/>
        <Route exact path ="/camp/:id" element={<CampDetail/>}/>
        <Route exact path ="/gallery" element={<GalleryPage/>}/>
        <Route exact path ="/camp" element={<Camp/>}/>
        <Route exact path ="/team" element={<Team/>}/>
        <Route exact path ="/developer" element={<Developer/>}/>
        </Routes>
      </div>
      <div className="">
        <Footer/>
      </div>
     </div>

    </>
  );
}

export default App;
